export default {
    whiteBigCentered: 'whiteBigCentered',
    whiteSmall:       'whiteSmall',
};